import React from "react";
import ImageGallery from "../components/ImageGallery/ImageGallery";
import ReactDOM from "react-dom";
import getRowData from "../assets/store/getRowData";
import { getDefaultFontFamily } from "../assets/store/getDefaultFontFamily";

const renderImageGalleries = () => {
    const rows = document.getElementsByClassName("ds-image-gallery-row");
    const drive_service_divs = window.DriveServiceSpecials.drive_service_divs;
    const oems = window.DriveServiceSpecials.oems;
    const { client } = window.DriveServiceSpecials;
    const { default_oem } = client;
    const defaultFontFamily = getDefaultFontFamily({
        fontFamily: client?.font_family,
    });

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const parent = drive_service_divs.find(
            (div) =>
                div.id === parseInt(row.parentElement.id.replace("ds-div-", ""))
        );
        let rowData = getRowData(parent.div_rows, parseInt(row.id));
        const { image_gallery } = rowData;
        row.style.setProperty(
            "background-color",
            image_gallery.background_color
        );

        ReactDOM.render(
            <ImageGallery
                image_gallery={image_gallery}
                divId={parent.id}
                rowId={rowData.id}
                rowData={rowData}
                defaultFontFamily={defaultFontFamily}
                isTableRow={
                    parent?.div_rows[rowData?.parentRowIndex]?.type ===
                    "table_row"
                }
                oem={default_oem || oems[0] || null}
                client={client}
            />,
            row
        );
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderImageGalleries();
window.renderImageGalleries = renderImageGalleries;

export default renderImageGalleries;
